import {
    ContactListViewModel,
    Contact,
    KeyValueOption,
    ListParams,
    SearchParams,
    CustomerAccount,
    SearchAssignmentsParams,
    UpdateContactsParams
} from "../model/contact";
import axios from "axios";
import { Organization } from "../../OrganizationManager/model/organization";
import { Address } from "../../AddressManager/model/address";

export const fetchContacts = async (params: ListParams): Promise<any> => {
    const res = await axios.get<ContactListViewModel>("Contacts/List", { params: params });
    return res.data;
};

export const fetchContactById = async (contactId?: string): Promise<Contact> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.get<Contact>(url + `Contacts/Get${contactId ? "?contactId=" + contactId : ""}`);
    return res.data;
};

export const searchContacts = async (params: SearchParams): Promise<any> => {
    if (params.query === null || params.query === "") {
        const res = await axios.get<ContactListViewModel>("Contacts/List", {
            params: {
                sortField: params.sortField,
                sortType: params.sortType,
                startIndex: params.startIndex,
                recordsToRetrieve: params.recordsToRetrieve,
                type: params.type
            },
        });
        return res.data;
    }
    const res = await axios.get<ContactListViewModel>(`Contacts/Search`, { params });
    return res.data;
};

export const deleteContacts = async (contactIds: string[]): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.delete<any>(url + "Contacts/Delete", { data: contactIds });
    return res.data;
};

export const updateContact = async (contact: Contact): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.post<any>(url + "Contacts/AddOrUpdate", contact);
    return res.data;
};

export const fetchCurrencies = async (): Promise<KeyValueOption[]> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.get<KeyValueOption[]>(url + "Common/GetCurrencies");
    return res.data;
};

export const fetchLanguages = async (): Promise<KeyValueOption[]> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.get<KeyValueOption[]>(url + "Common/GetLanguages");
    return res.data;
};

export const fetchAddressesByContactId = async (contactId: string): Promise<Address[]> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.get<Address[]>(url + "Addresses/GetByContactId?contactId=" + contactId);
    return res.data;
};

export const fetchOrganizations = async (): Promise<Organization[]> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.get<Organization[]>(url + "Organizations/List");
    return res.data;
};

export const fetchUserByContactId = async (contactId: string): Promise<CustomerAccount> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.get<CustomerAccount>(url + "Contacts/GetCustomerAccountByContactId?contactId=" + contactId);
    return res.data;
};

export const createCustomerAccount = async (account: CustomerAccount): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/EPiServer/Commerce/";
    const res = await axios.post<any>(url + "Contacts/CreateCustomerAccount", account);
    return res.data;
};


export const fetchUserAccountAssignments = async (contactId: string): Promise<Contact[]> => {
    const res = await axios.get<Contact[]>("Contacts/UserAccountAssignments?contactId=" + contactId);
    return res.data;
};

export const searchAvailableUserAccountAssignments = async (params: SearchAssignmentsParams): Promise<ContactListViewModel> => {
    const res = await axios.get<ContactListViewModel>("Contacts/AvailableUserAccountAssignments", { params: params });
    return res.data;
};

export const UpdateUserAccountAssignments = async (params: UpdateContactsParams): Promise<any> => {
    await axios.post<any>("Contacts/UpdateUserAccountAssignments", params);
};

